import React from 'react';
import { FillableSVGProps } from 'Src/types';

export default function HomeIcon({ filled, ...props }: FillableSVGProps) {
  if (filled) {
    return (
      <svg width="24" height="24" viewBox="0 0 22 22" fill="none" {...props}>
        <path
          d="M2.6 18.3499V13.5084H2.47547C0.642462 13.5084 -0.198477 10.8595 1.19646 9.47955L9.72099 1.04671C10.4579 0.317684 11.542 0.317682 12.279 1.04671L20.8035 9.47955C22.1985 10.8595 21.3575 13.5084 19.5245 13.5084H19.4V18.3499C19.4 19.5473 18.1051 21.4999 16.25 21.4999H5.75C4.7 21.4999 2.6 20.9749 2.6 18.3499ZM11 15.4999C10.1716 15.4999 9.5 16.1715 9.5 16.9999V19.9999H12.5V16.9999C12.5 16.1715 11.8284 15.4999 11 15.4999Z"
          fill="currentcolor"
        />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M2.6 18.35V13.5085H2.47547C0.642462 13.5085 -0.198477 10.8595 1.19646 9.47961L9.72099 1.04677C10.4579 0.317745 11.5421 0.317743 12.279 1.04677L20.8035 9.47961C22.1985 10.8595 21.3575 13.5085 19.5245 13.5085H19.4V18.35C19.4 19.5474 18.1051 21.5 16.25 21.5H5.75C4.7 21.5 2.6 20.975 2.6 18.35ZM17.3896 19.3888C17.7758 18.9454 17.9 18.4943 17.9 18.35V12.0085H19.5245C19.6068 12.0085 19.8168 11.9608 19.9448 11.5577C20.0716 11.1583 19.9751 10.7701 19.7486 10.546L11.2241 2.11315C11.1241 2.01424 11.0432 2 11 2C10.9568 2 10.8759 2.01424 10.7759 2.11315L2.25137 10.546C2.02485 10.7701 1.92841 11.1583 2.05517 11.5577C2.18316 11.9608 2.39325 12.0085 2.47547 12.0085H4.1V18.35C4.1 19.1925 4.40189 19.5128 4.64144 19.6805C4.96766 19.9089 5.42155 20 5.75 20H8V17C8 15.3431 9.34315 14 11 14C12.6569 14 14 15.3431 14 17V20H16.25C16.6235 20 17.029 19.8028 17.3896 19.3888ZM11 15.5C10.1716 15.5 9.5 16.1716 9.5 17V20H12.5V17C12.5 16.1716 11.8284 15.5 11 15.5Z"
        fill="currentcolor"
      />
    </svg>
  );
}

HomeIcon.defaultProps = {
  filled: false,
};
